import { normalizarTexto } from '../utils/texto';

// Quien gestiona vacantes desde la UI (el backend tambien deja al admin)
export const VACANTES_ADMIN_ROLES = ['gh', 'captacion'];

export const ESTADOS_VIGENTES = ['Abierta', 'En proceso'];

export const MOTIVOS = [
  { valor: 'Reemplazo', detalle: 'Alguien salió y hay que cubrir su puesto' },
  { valor: 'Nueva posición', detalle: 'Un puesto que no existía en el área' },
  { valor: 'Expansión', detalle: 'Una persona más en un puesto que ya existe' },
];

export const estadoClase = (estado) =>
  `vac-estado vac-estado--${normalizarTexto(estado || '').replace(/\s+/g, '-')}`;

export const asientoClase = (estado) => {
  if (estado === 'Cubierta') return 'vac-asiento vac-asiento--cubierta';
  if (estado === 'Cancelada') return 'vac-asiento vac-asiento--cancelada';
  if (estado === 'Congelada') return 'vac-asiento vac-asiento--congelada';
  return 'vac-asiento';
};

// Fechas de dia a medianoche local. Llegan como ISO (YYYY-MM-DD) o, desde
// /api/empleados, como fecha HTTP ('Thu, 11 Jun 2026 00:00:00 GMT'). Ambas
// vienen en UTC y en Venezuela caerian el dia anterior si se leen tal cual.
export const fechaLocal = (valor) => {
  if (!valor) return null;
  const texto = String(valor);
  if (/^\d{4}-\d{2}-\d{2}/.test(texto)) {
    const [y, m, d] = texto.slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const f = new Date(texto);
  return Number.isNaN(f.getTime()) ? null : new Date(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate());
};

export const diasDesde = (iso) => {
  const f = fechaLocal(iso);
  if (!f) return 0;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((hoy - f) / 86400000));
};

export const formatFecha = (iso) => {
  const f = fechaLocal(iso);
  return f ? f.toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';
};

export const diasClase = (dias) => {
  if (dias > 90) return 'vac-dias vac-dias--vieja';
  if (dias > 45) return 'vac-dias vac-dias--tibia';
  return 'vac-dias';
};

export const iniciales = (nombre) =>
  (nombre || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');

export const rutaPuesto = (v) =>
  [v.gerencia, v.departamento, v.area].filter(Boolean).join(' › ');

export const coincideBusqueda = (v, termino) => {
  const q = normalizarTexto(termino).trim();
  if (!q) return true;
  return normalizarTexto(
    [v.titulo, v.cargo, v.gerencia, v.departamento, v.area, v.supervisor_nombre].join(' ')
  ).includes(q);
};
